export default {
  id: 'notesAndSummaries/PERSONAL/v1',
  formSchema: {
    title: 'encounter:widget.notesAndSummaries.personal',
    type: 'object',
    required: ['id001'],
    properties: {
      id001: {
        type: 'string',
        title: 'encounter:widget.notesAndSummaries.personal',
        minLength: 1
      }
    }
  },
  uiSchema: {
    id001: { 'ui:widget': 'customCKEditorWidget' },
    'x-customClass': 'problem-description-widget'
  }
};
